import StockBalanceSummaryPreview from "./StockBalanceSummaryPreview";

const PrintStockBalanceSummary: React.FC = () => {
  return (
    <div className="inner-container">
      <StockBalanceSummaryPreview />
    </div>
  );
};

export default PrintStockBalanceSummary;
